import { render, staticRenderFns } from "./TournamentsNewView.vue?vue&type=template&id=6dbaa340"
import script from "./TournamentsNewView.vue?vue&type=script&lang=js"
export * from "./TournamentsNewView.vue?vue&type=script&lang=js"
import style0 from "./TournamentsNewView.vue?vue&type=style&index=0&id=6dbaa340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports